<template>
  <div class="flex flex-col items-center job-list_wrapper">
    <div class="flex items-center justify-center w-11/12 md:w-5/6 mb-12 max-w-4xl widget-search-bar__wrapper">
      <form class="flex flex-col sm:flex-row items-center w-full bg-white rounded widget-search-bar__form" @submit.prevent="onSubmit">
        <div class="w-full border-r-solid p-1 border-lightgray widget-search-input_autocomplete__wrapper"
             :class="[widgetConfig.SHOW_LOCATION_SEARCH || widgetConfig.SHOW_RANGE_SELECT ? 'sm:border-r' : 'border-0']">
          <div class="flex flex-row items-center mx-2 widget-search-input_autocomplete__component">
            <search-icon size="1.5x" class="mr-2 custom-icon-class"></search-icon>
            <el-input v-model="position"
                      :placeholder="$t('components.autocomplete.function')"
                      :trigger-on-focus=false
                      @select="handleSuggestionSelect"
                      value-key="keyword"
                      class="autocomplete-input">
            </el-input>
            <x-icon v-show="position" size="1x" class="cursor-pointer custom-icon-class"
                    @click="clearPosition"></x-icon>
          </div>
        </div>
        <div v-if="widgetConfig.SHOW_LOCATION_SEARCH"
             class="w-full flex flex-row items-center p-1 w-56 border-r-solid h-12 border-lightgray widget-location-search__wrapper"
             :class="[widgetConfig.SHOW_RANGE_SELECT ? 'sm:border-r' : 'border-0']">
          <div class="flex flex-row items-center w-full mx-2 widget-location-search__component">
            <map-pin-icon size="1.5x" class="mr-2 custom-icon-class"></map-pin-icon>
            <el-autocomplete v-model="location_name"
                             class="widget-autocomplete__component"
                             :placeholder="$t('components.input.location')"
                             value-key="label"
                             @select="onPlaceChanged"
                             :fetch-suggestions="querySearchLocation"
                             :trigger-on-focus="false"/>

            <x-icon size="1x" class="cursor-pointer ml-2 custom-icon-class" v-show="location_name"
                    @click="clearLocation"></x-icon>
          </div>
        </div>
        <div v-if="widgetConfig.SHOW_RANGE_SELECT" class="w-full max-w-xxs flex items-center widget-location-range__wrapper">
          <el-select v-model="range" class="w-full range-select" @change="onRangeChange">
            <el-option v-for="(item, key) in rangeOptions"
                       :key="key"
                       :label="item.label"
                       :value="item.value"/>
          </el-select>
        </div>
        <el-button class="p-3 mb-1 mx-1 w-full sm:w-auto sm:mb-0 widget-job-search__button" native-type="submit">
          <search-icon size="1.3x" class="text-bold"></search-icon>
        </el-button>
      </form>
    </div>
    <div class="flex flex-row justify-center md:justify-around md:min-w-7xl w-full widget-job-list__content">
      <div class="mr-3 md:w-2/6 widget-job-list-filters__wrapper" :class="{'order-1' : rightSideFilters, 'hidden' : !showFilters}">
        <JobListFilters :jobSegments="selectedSegments" @change="onSegmentsChange" @loading="load(true)"
                        @loadingFinished="load(false)"/>
      </div>
      <div class="flex flex-col items-center justify-start md:w-3/6">
        <div class="self-start w-full">
          <FiltersPreview class="filters-preview not-visible md:block" :segments="selectedSegments"
                          @change="onSegmentsChange"/>
        </div>
        <hr v-if="selectedSegments.length > 0" class="border-t-1 border-t-solid border-t-gray w-full h-2 mt-4 -mb-2"/>
        <div class="text-xl font-semibold w-full widget-list-job_count__wrapper">
          <div class="flex items-center justify-around h-20 text-black widget-list-job_count">
            <div v-if="loading" class="loader"></div>
            <div v-else>{{jobs.total}}
              <span>{{$tc('jobList.foundJob', jobs.total)}}</span>
            </div>
          </div>
        </div>
        <div class="w-full mb-4 max-w-2xl" v-for="job in jobs.data" :key="job.uuid">
          <JobItem :job="job"/>
        </div>
        <el-pagination :current-page="jobs.currentPage"
                       :page-size="jobsPerPage"
                       :pager-count="5"
                       @current-change="pageChange"
                       background
                       layout="pager"
                       :total="jobs.total">
        </el-pagination>
        <div v-if="widgetConfig.SHOW_CREATE_ALERT" class="flex justify-center mb-4 bg-white py-6 px-2 rounded mt-4 widget-job-alert__wrapper">
            <div class="sm:px-4 share-card__body widget-job_alert">
              <div class="flex items-center widget-job-alert__header">
                <bell-icon class="mr-2 text-primary"/>
                <span class="text-2xl text-primary" >{{$t('common.getNotified')}}</span>
              </div>
              <p class="mt-2 text-base break-normal widget-job-alert__text">{{$t('common.enterEmailToReceiveOffers')}}</p>
              <div class="mt-4 widget-job-alert_content__wrapper">
                <el-form class="widget-job-alert_content" :model="form" ref="form" label-position="top" :rules="validationRules">
                  <base-input v-model="form.email"
                              class="widget-job-alert_input"
                              prop="email"
                              :placeholder="$t('common.emailAddress')"
                              prefix-icon="el-icon-message"/>
                  <el-form-item class="mb-6 widget-job-alert_checkbox" prop="termsAccepted">
                    <el-checkbox-group v-model="form.termsAccepted">
                      <el-checkbox label="true"
                                   class="mt-2"
                                   name="termsAccepted">
                        <div class="text-gray-700"><span class="text-red-400">* </span>{{$t('common.readAndAcceptTerms')}}</div>
                      </el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                  <div class="flex justify-center mt-8 widget-job-alert_create-button">
                    <el-button type="secondary"
                               class="w-full"
                               @click="createAlert">
                      <bell-icon class="mr-2"/>
                      <span>{{$t('common.createAlert')}}</span>
                    </el-button>
                  </div>
                </el-form>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
  import isEqual from 'lodash/isEqual'
  import BaseInput from '../components/inputs/BaseInput'
  import JobItem from '../components/JobItem.vue'
  import JobListFilters from '../components/filters/JobListFilters'
  import listParamsMixin from '../util/mixins/listParamsMixin'
  import queryParamsMixin from '../util/mixins/queryParamsMixin'
  import FiltersPreview from '../components/filters/FiltersPreview'
  import { MapPinIcon, SearchIcon, XIcon, BellIcon } from 'vue-feather-icons'
  import { RANGE_OPTIONS } from '../util/rangeOptions'
  import { TRACKING_EVENTS } from '../enum/tracking'
  import { CheckboxGroup, Notification } from 'element-ui'
  import { createAlert } from '../API/alert'
  import { getCountries } from '../API/autocomplete'

  export default {
    name: 'job-list',
    components: {
      BaseInput,
      BellIcon,
      FiltersPreview,
      JobItem,
      JobListFilters,
      MapPinIcon,
      // eslint-disable-next-line vue/no-unused-components
      Notification,
      SearchIcon,
      XIcon,
      'el-checkbox-group': CheckboxGroup,
    },
    mixins: [listParamsMixin, queryParamsMixin],
    data () {
      return {
        form: this.initFormData(),
        location_name: '',
        position: '',
        range: 10,
        rangeOptions: RANGE_OPTIONS,
        widgetConfig: {},
        loading: false,
      }
    },
    watch: {
      jobs (newValue) {
        this.$analytics(TRACKING_EVENTS.JOB_SEARCH, {
          eventLabel: JSON.stringify(this.$route.query),
          eventValue: newValue.total
        })
      }
    },
    async mounted () {
      this.widgetConfig = this.$store.getters['widgetConfig']
      const locationName = this.$route.query['location_name']
      const position = this.$route.query['search']

      if (position) {
        this.position = position
      }

      if (!this.widgetConfig.SHOW_LOCATION_SEARCH) {
        return
      }

      if (locationName) {
        this.location_name = locationName
      }

      this.$analytics(TRACKING_EVENTS.JOB_SEARCH, {
        eventLabel: JSON.stringify(this.$route.query),
        eventValue: this.jobs.total
      })
    },
    computed: {
      validationRules() {
        return {
          email: [
            { required: true, message: this.$t('jobApply.emailRequired'), trigger: 'blur' },
            { type: 'email', message: this.$t('jobApply.validEmail'), trigger: 'blur' }
          ],
          termsAccepted: [
            { type: 'array', required: true, message: this.$t('jobApply.checkboxRequired'), trigger: 'change' }
          ]
        }
      },
      rightSideFilters() {
        const position = this.widgetConfig.SEGMENT_LIST_POSITION
        return position === 'right';
      },
      showFilters() {
        const visible = this.widgetConfig.SHOW_SEGMENT_LIST
        return visible === true;
      },
      jobs () {
        return this.$store.state.allJobs
      },
      segments () {
        return this.$store.state.allJobs.aggregations
      }
    },
    methods: {
      initFormData() {
        return {
          email: null,
          termsAccept: false,
          termsAccepted: [],
        }
      },
      async createAlert() {
        try {
          await this.$refs.form.validate()
          await createAlert({email: this.form.email})
          Notification.success({ message: this.$t('common.jobAlertCreated') })
          this.$refs.form.resetFields()
        } catch (e) {
          console.log(e)
        }
      },
      load (value) {
        this.loading = value
      },
      onRangeChange() {
        this.onSubmit()
      },
      async querySearchLocation(queryString, cb) {
        let countries;
        let autocompleteCountries = this.$store.getters['countries']
        autocompleteCountries = autocompleteCountries.map(c => c.code).toString()

        if (queryString.length > 1) {
          countries = await getCountries(queryString, autocompleteCountries)
        } else {
          cb([]);
          return
        }
        cb(countries);
      },
      onPlaceChanged(place) {
        if (Object.keys(place).length === 0) {
          this.location_name = ''
          this.onSubmit()
          return
        }
        this.location_name = place.label
        this.onSubmit()
      },
      onSubmit (event, extraQuery = {}) {
        const query = {
          ...this.$route.query,
          'search': this.position || undefined,
          'distance': this.range || undefined,
          'location_name': this.location_name || undefined,
          'page': 1,
          ...extraQuery
        }

        if (isEqual(this.$route.query, query)) {
          return
        }

        this.$router.push({ query: query })
      },
      clearLocation () {
        this.location_name = null
        this.onPlaceChanged({})
      },
      clearPosition () {
        this.position = ''
        this.onSubmit()
      },
      handleSuggestionSelect (item) {
        const query = {
          'search': item.keyword,
          ...this.getSegmentsQuery(item.query.segments)
        }

        this.onSubmit(null, query)
      }
    }
  }
</script>
<style lang="scss">
.share-card__body {
  .el-input {
    .el-input__inner {
      @apply pl-8;
    }

    .el-input__prefix {
      @apply mr-2;
      i {
        @apply flex items-center;
        font-size: 22px;
      }
    }
  }
}
.widget-location-search__wrapper {
  .el-autocomplete {
    @apply w-full;
  }

  .el-input {
    .el-input__inner {
      @apply px-0 border-none;
    }
  }
}
</style>
